import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal} from '@angular/core';
import {WjGridModule} from '@mescius/wijmo.angular2.grid';
import {ConfigMatrix, ConfigMatrixApi, ConfigMatrixValue} from '../../../api-client-kt/src';
import {WjNavModule} from '@mescius/wijmo.angular2.nav';
import {WjGridFilterModule} from '@mescius/wijmo.angular2.grid.filter';
import {WjGridSearchModule} from '@mescius/wijmo.angular2.grid.search';
import {PortfolioDataContext} from '../../data/portfolio-data-context.service';
import {AppConfigMatrixComponent} from '../../components/app-config-matrix/app-config-matrix.component';

@Component({
    selector: 'app-portfolio-config-data',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjNavModule,
        WjGridModule,
        WjGridFilterModule,
        WjGridSearchModule,
        AppConfigMatrixComponent
    ],
    templateUrl: './portfolio-config-data.component.html',
    styleUrl: './portfolio-config-data.component.scss'
})
export class PortfolioConfigDataComponent implements OnInit {

    protected readonly categories = signal<string[]>([]);

    protected configMatrices: ConfigMatrix[] = [];
    protected configMatrixValues: { [key: string]: ConfigMatrixValue[] } = {};

    protected readonly pfData = inject(PortfolioDataContext);
    private readonly cfgMatrixApi = inject(ConfigMatrixApi);

    async ngOnInit(): Promise<void> {
        // we must not update the view until after the initial ngOnInit() is finished
        // otherwise Angular throws an ExpressionChangedAfterItHasBeenCheckedError
        // for the value of the tab headers
        setTimeout(async () => this.loadData(), 0);
    }

    async loadData(): Promise<void> {
        const matrices = await this.cfgMatrixApi.getConfigMatrices({ id: this.pfData.portfolioId()! });
        const categories = [...new Set(matrices.map(m => m.category))];
        this.configMatrices = matrices;

        const matrixValuePromises = this.configMatrices.map(async (m) => {
            return this.cfgMatrixApi.getConfigMatrixValues({ id: this.pfData.portfolioId()!, key: m.key });
        });
        const matrixValues = await Promise.all(matrixValuePromises);

        this.configMatrixValues = {};
        matrixValues.forEach((values, i) => {
            this.configMatrixValues[matrices[i].key] = values;
        });

        this.categories.set(categories);
    }

    matrices(category: string): ConfigMatrix[] {
        return this.configMatrices.filter(m => m.category === category);
    }

}
